import { render, staticRenderFns } from "./index.vue?vue&type=template&id=563cadb8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=563cadb8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563cadb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vagrant/git/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('563cadb8')) {
      api.createRecord('563cadb8', component.options)
    } else {
      api.reload('563cadb8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=563cadb8&scoped=true", function () {
      api.rerender('563cadb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/labor_notice/index.vue"
export default component.exports